<template>
    <div slot="content">
        ${{ nextIdx }}
        <el-steps :active="nextIdx" finish-status="success" :direction="direction" align-center>
            <el-step :space="space" :title="step.title" :description="step.description" v-for="(step, idx) in steps" :key="idx" />
        </el-steps>
        <button @click="resultData">체크</button>
        <step-one ref="step1" v-if="active === 1"></step-one>
    
        <step-two ref="step2" v-else-if="active === 2"></step-two>
    
        <step-three ref="step3" v-else-if="active === 3"></step-three>

        
    </div>
</template>

<script>
import StepOne from '@/components/AS/Step/StepOne.vue';
import StepTwo from '@/components/AS/Step/StepTwo.vue';
import StepThree from '@/components/AS/Step/StepThree.vue'; 

export default {
    props: {
        active: {
            Type: Number,
            default: 1,
            require: true
        },
        steps: {
            Type: Array,
            require: false
        },
        space: {
            Type: Number,
            default: 200,
            require: false
        },
        direction: {
            Type: String,
            default: "horizontal",
            required: false,
        }
    },
    components: {StepOne, StepTwo, StepThree},
    data() {
        return {
            
        }
    },
    computed: {
        nextIdx(){
            return this.active;
        }
    },
    methods: {
        // next() {
        //     if (this.nextIdx++ > this.steps.length-1) {
        //         this.nextIdx = 0;
        //     }
        // }
        resultData() {
            
            // return _.cloneDeep(_.merge(this.$refs.step1, this.$refs.step2, this.$refs.step3))
        }
    }
}
</script>
